import store from '@/store'
import pub from '@/utils/public'

//保存数据不带ID为新增，带ID为更新
const save = async (params,url) => {
    let token = localStorage.getItem('token');
    let data = encodeURI(JSON.stringify(params))
    let key_data = pub.encrypt(data, token);

    let param = {
        url:url,
        param:{
            token: token,
            data: key_data
        }
    }
    const ret = await store.dispatch('pubMethod', param)
    return ret;
}

const saveNoToken = async (params,url) => {
    let param = {
        url:url,
        param:{
            ...params
        }
    }
    const ret = await store.dispatch('pubMethod', param)
    return ret;
}

export default {
    save,saveNoToken
}